import {
  ApproverDelegatee,
  type ApproverDelegateeConstructor,
} from '@webapp/core/entities/internal/ApproverDelegatee'

export interface RequestableApproverOptionConstructor {
  id: number
  userId: number
  firstName: string
  lastName: string
  levelText: Nullable<string>
  groupName: Nullable<string>
  approvalDelegatee: Nullable<ApproverDelegateeConstructor>
}

export class RequestableApproverOption {
  readonly id: number
  readonly userId: number
  readonly firstName: string
  readonly lastName: string
  readonly levelText: Nullable<string>
  readonly groupName: Nullable<string>
  readonly approvalDelegatee: Nullable<ApproverDelegatee>

  constructor(data: RequestableApproverOptionConstructor) {
    this.id = data.id
    this.userId = data.userId
    this.firstName = data.firstName
    this.lastName = data.lastName
    this.levelText = data.levelText || null
    this.groupName = data.groupName || null
    this.approvalDelegatee = data.approvalDelegatee
      ? new ApproverDelegatee(data.approvalDelegatee)
      : null
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`
  }

  get displayLabel(): string {
    return this.levelText ? `${this.fullName} ${this.levelText}` : this.fullName
  }

  get hasApprovalDelegatee(): boolean {
    return this.approvalDelegatee !== null
  }
}
